// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Zku5","productName":"Table_productName__TTYpD"};